import {
  Box,
  Button,
  Card,
  CardContent,
  installColorScheme,
  Text,
  useTour,
} from "@prismicio/editor-ui"
import { useState } from "react"

import { mainContentMaxWidth } from "../../../document/documentLayout"
import { trackDemoCta } from "../../analytics/tracking"
import { DevDialog } from "../DevDialog"
import { GetStartedDialog } from "../GetStartedDialog"

export const demoWelcomeBannerHeight = 78

export function DemoHeaderBanner() {
  const [openDialogID, setOpenDialogID] = useState<"dev" | "getStarted">()
  const tour = useTour()

  function closeDialog() {
    setOpenDialogID(undefined)
  }

  return (
    <Box
      height={demoWelcomeBannerHeight}
      flexShrink={0}
      justifyContent="center"
      alignItems="flex-start"
      padding={{ top: 16, bottom: 4 }}
      position="relative"
    >
      <Box
        maxWidth={mainContentMaxWidth}
        width="100%"
        padding={{ inline: 2 }}
        position="relative"
      >
        <Card
          ref={installDarkColorScheme}
          paddingBlock={12}
          sx={{ width: "100%" }}
        >
          <CardContent>
            <Box alignItems="center">
              <Box flexGrow={1}>
                <Button
                  invisible
                  color="white"
                  size="large"
                  startIcon="playCircle"
                  disabled={tour.isActive}
                  onClick={() => tour.start()}
                >
                  Take the guided tour
                </Button>
                <Text color="grey11" sx={{ marginInline: 8 }}>
                  or
                </Text>
                <Button
                  invisible
                  color="white"
                  size="large"
                  startIcon="code"
                  disabled={tour.isActive}
                  onClick={() => {
                    setOpenDialogID("dev")
                    trackDemoCta("Explore the website's code", {
                      position: "demo banner",
                      type: "secondary",
                    })
                  }}
                >
                  Explore the website's code
                </Button>
                <DevDialog
                  open={openDialogID === "dev"}
                  onOpenChange={closeDialog}
                />
              </Box>
              <Text color="grey11" sx={{ marginRight: 12 }}>
                Ready to start using Prismic?
              </Text>
              <Button
                ref={installLightColorScheme}
                size="medium"
                endIcon="arrowForward"
                color="grey"
                onClick={() => setOpenDialogID("getStarted")}
              >
                Get started
              </Button>
              <GetStartedDialog
                open={openDialogID === "getStarted"}
                onOpenChange={closeDialog}
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  )
}

function installDarkColorScheme(element: HTMLElement | null) {
  if (element) installColorScheme(element, "dark")
}

function installLightColorScheme(element: HTMLElement | null) {
  if (element) installColorScheme(element, "light")
}
